import { Config } from '../../config/config.es6';

export default class TopView {
    constructor() {}

    tab() {
        // TODO: 無駄が多いので書き直す
        if (document.getElementById('et_contents2') != null) {
            const element_id = document.getElementById('et_contents2');
            const tabList = element_id.querySelectorAll('.js-tab-list');

            for (let i = 0; i < tabList.length; i++) {
                tabList[i].addEventListener('click', tabSwitch);
            }

            function tabSwitch() {
                // current
                element_id.querySelectorAll('.current')[0].classList.remove('current');
                this.classList.add('current');

                element_id.classList.remove('q5', 'q4', 'q3', 'j2', 'j2p', 'q2', 'j1');
                element_id.classList.add(this.dataset.tool);

                COMMON.scrollFunc.refresh();
            }
        }
    }
}
